import {
	AlignCenterHorizontal,
	AlignLeft,
	AlignRight,
	Bold,
	Italic,
	Underline,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Section } from "./section";

export function ControlsSection() {
	return (
		<>
			<Section title="Przyciski">
				<Card>
					<CardContent className="pt-6">
						<div className="flex flex-col gap-6">
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">Warianty</p>
								<div className="flex flex-wrap gap-2">
									<Button>Default</Button>
									<Button variant="secondary">Secondary</Button>
									<Button variant="outline">Outline</Button>
									<Button variant="ghost">Ghost</Button>
									<Button variant="destructive">Destructive</Button>
									<Button variant="link">Link</Button>
								</div>
							</div>
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">Rozmiary</p>
								<div className="flex flex-wrap items-center gap-2">
									<Button size="lg">Large</Button>
									<Button>Default</Button>
									<Button size="sm">Small</Button>
									<Button size="xs">Extra Small</Button>
								</div>
							</div>
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">Stany</p>
								<div className="flex flex-wrap gap-2">
									<Button disabled>Disabled</Button>
									<Button disabled variant="outline">
										Disabled Outline
									</Button>
								</div>
							</div>
						</div>
					</CardContent>
				</Card>
			</Section>

			<Section title="Odznaki (Badge)">
				<Card>
					<CardContent className="pt-6">
						<div className="flex flex-col gap-4">
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">Podstawowe</p>
								<div className="flex flex-wrap gap-2">
									<Badge>Default</Badge>
									<Badge variant="secondary">Secondary</Badge>
									<Badge variant="outline">Outline</Badge>
									<Badge variant="destructive">Destructive</Badge>
								</div>
							</div>
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">Semantyczne</p>
								<div className="flex flex-wrap gap-2">
									<Badge variant="success">Success</Badge>
									<Badge variant="warning">Warning</Badge>
									<Badge variant="info">Info</Badge>
									<Badge variant="water">Water</Badge>
									<Badge variant="heat">Heat</Badge>
									<Badge variant="energy">Energy</Badge>
								</div>
							</div>
						</div>
					</CardContent>
				</Card>
			</Section>

			<Section title="Pola formularza">
				<Card>
					<CardContent className="pt-6">
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg">
							<div className="grid gap-2">
								<Label htmlFor="ds-input">Input</Label>
								<Input id="ds-input" placeholder="Wpisz wartość…" />
							</div>
							<div className="grid gap-2">
								<Label htmlFor="ds-input-disabled">Input wyłączony</Label>
								<Input
									id="ds-input-disabled"
									value="Wartość tylko do odczytu"
									disabled
								/>
							</div>
							<div className="grid gap-2 sm:col-span-2">
								<Label htmlFor="ds-textarea">Textarea</Label>
								<Textarea id="ds-textarea" placeholder="Wpisz dłuższy tekst…" />
							</div>
							<div className="grid gap-2">
								<Label>Select</Label>
								<Select>
									<SelectTrigger className="w-full">
										<SelectValue placeholder="Wybierz opcję…" />
									</SelectTrigger>
									<SelectContent>
										<SelectItem value="a">Opcja A</SelectItem>
										<SelectItem value="b">Opcja B</SelectItem>
										<SelectItem value="c">Opcja C</SelectItem>
									</SelectContent>
								</Select>
							</div>
							<div className="flex flex-col gap-3">
								<div className="flex items-center gap-2">
									<Checkbox id="ds-check" />
									<Label htmlFor="ds-check">Checkbox</Label>
								</div>
								<div className="flex items-center gap-2">
									<Checkbox id="ds-check-2" defaultChecked />
									<Label htmlFor="ds-check-2">Domyślnie zaznaczony</Label>
								</div>
							</div>
						</div>
					</CardContent>
				</Card>
			</Section>

			<Section title="Toggle Group">
				<Card>
					<CardContent className="pt-6">
						<div className="flex flex-col gap-4">
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">
									Pojedynczy wybór
								</p>
								<ToggleGroup type="single" defaultValue="left">
									<ToggleGroupItem value="left" aria-label="Align left">
										<AlignLeft className="size-4" />
									</ToggleGroupItem>
									<ToggleGroupItem value="center" aria-label="Align center">
										<AlignCenterHorizontal className="size-4" />
									</ToggleGroupItem>
									<ToggleGroupItem value="right" aria-label="Align right">
										<AlignRight className="size-4" />
									</ToggleGroupItem>
								</ToggleGroup>
							</div>
							<div className="flex flex-col gap-2">
								<p className="text-sm text-muted-foreground">
									Wielokrotny wybór
								</p>
								<ToggleGroup type="multiple" defaultValue={["bold"]}>
									<ToggleGroupItem value="bold" aria-label="Bold">
										<Bold className="size-4" />
									</ToggleGroupItem>
									<ToggleGroupItem value="italic" aria-label="Italic">
										<Italic className="size-4" />
									</ToggleGroupItem>
									<ToggleGroupItem value="underline" aria-label="Underline">
										<Underline className="size-4" />
									</ToggleGroupItem>
								</ToggleGroup>
							</div>
						</div>
					</CardContent>
				</Card>
			</Section>
		</>
	);
}
